mutation PayCycleApprovalCreate($input: PayCycleApprovalCreateInput!) {
  payCycleApprovalCreate(input: $input) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}
